import useFeatureFlags from 'common/hooks/useFeatureFlags';
import useUser from 'common/hooks/useUser';

const useBrandPayoutReportsFeatureFlag = (brandId: string) => {
  const { isEmployee, user } = useUser();
  const userId = user?.id || '';

  const { data } = useFeatureFlags(['enable_brand_level_payout'], {
    user_id: userId,
    is_employee: isEmployee,
    brandId,
  });

  return data?.enable_brand_level_payout === 'on';
};

export default useBrandPayoutReportsFeatureFlag;
